// Stable, English paywall surface ids. Sent as the `surface` dimension of the
// `paywall_viewed` analytics event and used in the (English) WhatsApp prefill to
// the account manager — never translated. Values equal the English paywall titles
// the surfaces sent before i18n, so GA4 reporting continuity holds.
export const PAYWALL_SURFACE = {
  dashboard: 'Unlock your Insiders dashboard',
  ask: 'Ask anything about Dubai off-plan',
  developerVault: 'Unlock the Developer Vault',
  news: 'Live market news & intel',
  explore: 'Browse the full Dubai inventory',
  developers: 'Every Dubai developer, tracked',
  deals: 'Your deals pipeline',
  payments: 'Earnings & withdrawals',
  referrals: 'Your referral program',
  offers: 'Client catalogue generator',
  marketing: 'Generate branded marketing in seconds',
  fastPay: 'Get paid within 7 days of SPA',
} as const;

export type PaywallSurface = (typeof PAYWALL_SURFACE)[keyof typeof PAYWALL_SURFACE];
